import React, { type FC } from 'react';

export type AccessRequestsDialogBodyProps = {};

export const AccessRequestsDialogBody: FC<AccessRequestsDialogBodyProps> = (_) => {
	return <div>Woo hoo!</div>;
};
